<template>
  <div class="">
    <div class="u-flex" style="margin-top: 16px">
      <Button  v-nohasPermi="['m3', 'm4']" v-if="userRole.indexOf('m') >= 0" type="primary" @click="adddig">
        <Icon type="md-add" />新增诊断报告</Button
      >
    </div>
    <template v-if="isdisble">
      <div class="common-list">
        <Table :columns="columns" :data="diagnosticReportList"></Table>
      </div>
      <div class="common-page fr" v-if="pageInfo.total">
        <!-- <Page  show-total show-elevator show-sizer :total="pageInfo.total" :current="pageInfo.current"
      :page-size='pageInfo.size' @on-change='getWarningLists' @on-page-size-change='getRuleListsSize'>
        </Page> -->
        <Page
          show-elevator
          show-total
          show-sizer
          :total="pageInfo.total"
          :current="pageInfo.current"
          @on-page-size-change="getRuleListsSize"
          :page-size="pageInfo.size"
          @on-change="paggetLists"
        ></Page>
      </div>
    </template>
    <DiaMoudl
      :showDrawer="showDrawer"
      :closeDrawer="closeDrawer"
      :getLists="getLists"
      :curItemDetail="curItemDetail"
      :dataCenter="dataCenter"
      :staus="1"
      :nvtodetl="nvtodetl1"
      :curId="curId"
    />
  </div>
</template>

<script>
import store from "store2";
import { mapState } from "vuex";
import DiaMoudl from "@/views/warning/components/diagnostic-drawer.vue";
import suceess from "@/assets/images/icon/green-success.png";
import water from "@/assets/images/icon/water.png";
import ls from "store2";

import {
  equipmentTree,
  delpmentTree,
  oilSiteModelPublish,
  oilSiteModelread,
  diagnosticcancel,
} from "@/api/warning/diagnostic";
export default {
  components: {
    DiaMoudl,
  },
  props: ["char", "oilSiteModelVOList", "curId"],
  computed: {
    ...mapState({
      dataCenter: (state) => state.dataCenter,
    }),
  },
  data() {
    return {
      isdisble: false,
      columns: [],
      data: [],
      curItemDetail: {},
      pageInfo: {
        current: 1,
        size: 10,
        total: 100,
      },
      showDrawer: false,
      userRole: ls.get("userRole"),
      diagnosticReportList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    bmaro(value) {
      if (this.userRole.indexOf("m") > -1) {
        if (this.userRole == "m0" && !value) {
          return false;
        }
        return true;
      }
    },
    paggetLists(index) {
      this.pageInfo.current = index;

      this.getLists();
    },
    getRuleListsSize(size) {
      this.pageInfo.size = size;
      this.getLists(1);
    },
    nvtodetl1(item) {
      const routeUrl = this.$router.resolve({
        path: `/business/diaticreport?id=${item.id}`,
      });
      window.open(routeUrl.href, "_blank");
    },
    async del(item) {
      //
      this.$Modal.confirm({
        title: `您确定要删除该报告吗？`,
        content: `报告名称：${item.name}`,
        onOk: async () => {
          let data = await delpmentTree(item.id);
          if (data.code == "00000") {
            this.$Message.success("删除成功");
            this.getLists();
          } else {
            this.$Message.info(data.msg);
          }
        },
        onCancel: () => {},
      });
    },
    closeDrawer() {
      this.showDrawer = false;
      this.curItemDetail = {};
    },
    async nvtodetl(item, text = "look") {
      const { state, isRead, id } = item;
      if (state == 20 && !isRead) {
        oilSiteModelread(id);
        this.$store.dispatch("setqueNum");
      }
      const routeUrl = this.$router.resolve({
        path: `/business/lookdiaticreport?id=${item.id}&text=${text}`,
      });
      window.open(routeUrl.href, "_blank");
    },
    init() {
      this.$store.dispatch("dataCenter", "oilSiteLabel"); // 润滑油标签
      this.columns = [
        {
          title: "序号",
          // fixed: "left",
          type: "index",
          align: "left",
          width: 80,
        },
        {
          title: "报告名称",
          key: "name",
          // fixed: "left",
          align: "left",
          // width: "140",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.name || "-");
          },
        },
        {
          title: "状态",
          align: "left",
          width: "100",
          render: (h, params) => {
            const { state, isRead } = params.row;
            let text = "";
            if (state == 10) {
              text = "-";
            } else {
              text = isRead ? "已读" : "未读";
            }
            if (state == 10) {
              return h("div", text);
            } else {
              return h("div", { class: "u-flex" }, [
                h(
                  "div",
                  {
                    class: !isRead ? " errstatus" : "succstatus",
                  },
                  ""
                ),
                h(
                  "div",
                  { style: { "font-size": "12px", "margin-left": "5px" } },
                  text
                ),
              ]);
            }
          },
        },

        {
          title: "创建时间",
          key: "gmtCreate",
          align: "left",
          // width: "200",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.gmtCreate || "-");
          },
        },

        {
          title: "发布状态",
          align: "left",
          // width: "200",
          render: (h, params) => {
            const { state } = params.row;
            return h(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                  //   'justify-content': 'center'
                },
              },
              [
                h("img", {
                  style: {
                    width: "14px",
                    height: "14px",
                    marginRight: "5px",
                  },

                  attrs: {
                    src: state == 10 ? water : suceess,
                  },
                }),
                h(
                  "div",
                  {
                    style: {
                      fontSize: "12px",
                    },
                  },
                  state == 10 ? "未发布" : "已发布"
                ),
              ]
            );
          },
        },
        {
          title: "发布时间",
          key: "issueNewestTime ",
          align: "left",
          // width: "200",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.issueNewestTime || "-");
          },
        },

        {
          title: "创建人",
          key: "creatorName ",
          align: "left",
          // width: "200",
          render: (h, params) => {
            const item = params.row;
            return h("div", item.creatorName);
          },
        },

        {
          title: "操作",
          key: "address",
          align: "left",
          // fixed: "right",
          // width: 200,
          className: "action",
          render: (h, params) => {
            const item = params.row;
            let show0 = h("div", [
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                    // marginRight: "10px"
                    display: this.bmaro(item.selfOrNot) ? "" : "none",
                  },
                  on: {
                    click: async () => {
                      // this.nvtodetl(item)
                      this.nvtodetl(item, "fabu");
                      // this.$Modal.confirm({
                      //   title: `确定要发布吗`,
                      //   onOk: async () => {
                      //      let data = await oilSiteModelPublish(item.id)
                      //     if (data.code == "00000") {
                      //       this.$Message.success('发布成功');
                      //       this.getLists();

                      //     } else {
                      //       this.$Message.info(data.msg);
                      //     }
                      //   },
                      // });
                    },
                  },
                },
                "发布"
              ),
              h(
                "span",
                {
                  style: {
                    // display: this.userRole.indexOf('m1') < 0 ? 'none' : 'inline-block',
                    display: "inline-block",
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                    display: this.bmaro(item.selfOrNot) ? "" : "none",
                  },
                },
                "|"
              ),

              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                    // marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.nvtodetl(item);
                    },
                  },
                },
                "预览"
              ),
              h(
                "span",
                {
                  style: {
                    // display: this.userRole.indexOf('m1') < 0 ? 'none' : 'inline-block',
                    // display:'inline-block',
                    display: this.bmaro(item.selfOrNot) ? "" : "none",
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                  },
                },
                "|"
              ),

              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                    // marginRight: "10px"
                    display: this.bmaro(item.selfOrNot) ? "" : "none",
                  },
                  on: {
                    click: () => {
                      this.del(item);
                    },
                  },
                },
                "删除"
              ),
            ]);
            let show1 = h("div", [
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                    // marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      let downloadElement = document.createElement("a");

                      downloadElement.href = item.url;

                      document.body.appendChild(downloadElement);
                      downloadElement.click();
                      document.body.removeChild(downloadElement);
                    },
                  },
                },
                "下载"
              ),
              h(
                "span",
                {
                  style: {
                    // display: this.userRole.indexOf('m1') < 0 ? 'none' : 'inline-block',
                    display: "inline-block",
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                    // marginRight: "10px"
                  },
                  on: {
                    click: () => {
                      this.nvtodetl(item);
                    },
                  },
                },
                "查看"
              ),
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    color: "#ddd",
                    margin: "0 10px",
                    verticalAlign: "middle",
                    display: item.canCancel == 0 ? "none" : "",
                  },
                },
                "|"
              ),
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                    display: item.canCancel == 0 ? "none" : "",
                    // marginRight: "10px"
                  },
                  on: {
                    click: async () => {
                      this.$Modal.confirm({
                        title: `确定撤回报告吗`,
                        onOk: async () => {
                          let data = await diagnosticcancel(item.id);
                          if (data.code == "00000") {
                            this.$Message.success("撤回成功");
                            this.getLists();
                          } else {
                            this.$Message.info(data.msg);
                          }
                        },
                      });
                    },
                  },
                },
                "撤回"
              ),
            ]);
            return item.state == 10 ? show0 : show1;
          },
        },
      ];

      // 权限
      if (["c0", "c1"].indexOf(this.userRole) > -1) {
        this.columns = this.columns
          .filter((col) => col.title !== "创建时间")
          .filter((col) => col.title !== "发布状态")
          .filter((col) => col.title !== "创建人");
      }

      this.getLists();
    },
    async getLists(index = 1) {
      this.isdisble = false;
      let { data } = await equipmentTree({
        ...{
          oilSiteId: this.curId,
        },
        ...this.pageInfo,
      });

      this.isdisble = true;
      this.diagnosticReportList = data.records;
      this.pageInfo.total = data.total;
    },

    adddig() {
      // this.adddig=true
      this.showDrawer = true;
      //  store.set('diatice',{
      //     char:this.char,
      //     oilSiteModelVOList:this.oilSiteModelVOList
      //  })
      // this.$router.push('/business/diaticreport')
    },
  },
};
</script>